export function ConvertMinutesToMilliseconds(minutes: number): number {
  return minutes * 60 * 1000;
}
